<template>
  <div class="page-content-mobile">
    <!-- 头部banner -->
    <div class="banner">
      <div class="introduce">
        <div class="introduce-title">
          接入AI大模型的智能客服系统
        </div>
        <div class="introduce-desc">
          通全平台、懂产品、会营销多维赋能电商
        </div>
      </div>
    </div>

    <!-- 板块1：驱动电商服务的智能跃迁 -->
    <div class="section">
      <div class="title-box">
        <div class="title-text">
          驱动电商服务的智能跃迁
        </div>
        <div class="title-line">
          四维升级，重构电商服务竞争力
        </div>
      </div>

      <div class="switch-section">
        <div class="switch-buttons">
          <div :class="['switch-btn', { active: currentIndex === 0 }]" @click="currentIndex = 0">
            <div class="switch-btn-title">人力释放革命</div>
          </div>
          <div :class="['switch-btn', { active: currentIndex === 1 }]" @click="currentIndex = 1">
            <div class="switch-btn-title">零等待体验</div>
          </div>
        </div>

        <div class="switch-images">
          <div class="switch-img-box" v-if="currentIndex === 0">
            <img :src="switchImg1" alt="人力释放革命" class="switch-img" />
          </div>
          <div class="switch-img-box" v-else>
            <img :src="switchImg2" alt="零等待体验" class="switch-img" />
          </div>
        </div>
      </div>
    </div>

    <!-- 板块2：全栈靶向适配 -->
    <div class="section">
      <div class="title-box">
        <div class="title-text">
          <div>全栈靶向适配</div>
          <div class="title-text2">让AI生长于您的业务基因</div>
        </div>
      </div>

      <div class="features-grid">
        <div v-for="item in section2List" :key="item.title" class="feature-card"
          :style="{ backgroundImage: `url(${hoverBg})` }">
          <div class="feature-header">
            <span class="feature-title">{{ item.title }}</span>
            <span class="feature-subtitle">{{ item.subtitle }}</span>
          </div>
          <div class="feature-desc" v-for="desc in item.desc" :key="desc">{{ desc }}</div>
        </div>
      </div>
    </div>

    <!-- 板块3：选择智寰的理由 -->
    <div class="section">
      <div class="title-box">
        <div class="title-text">
          选择智寰的理由
        </div>
        <div class="title-line">
          <div>千亿级大模型为底座 × 电商垂直场景深度驯化</div>
          <div>上千家企业实战验证，打造更懂生意增长的AI技术引擎</div>
        </div>
      </div>

      <div class="reasons">
        <!-- 理由1 -->
        <div class="reason-item">
          <div class="reason-content">
            <div class="reason-title">千亿级大模型加持，更智能</div>

            <!-- 勾选列表 -->
            <div class="tick-list">
              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span class="tick-label">基于混合专家系统（MoE）的稀疏激活架构，在1.2万亿token电商语料上预训练，包含1120亿有效参数（经知识蒸馏压缩）。</span>
                </div>
              </div>

              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span class="tick-label">商品认知引擎：精准解析百万级SKU属性（如服装的“桑蚕丝含量”“立体剪裁工艺”）</span>
                </div>
              </div>

              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span class="tick-label">跨会话意图追踪：用户30天内咨询记录深度关联分析</span>
                </div>
              </div>

              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span class="tick-label">效能保障：经2025年618实战验证，单GPU节点可承载8.5万QPS并发问答，响应延迟稳定在380ms±20ms</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 保留整个图片 -->
          <div class="reason-img-wrap">
            <img :src="reasonImg1" alt="千亿级大模型" class="reason-img reason-img1" />
          </div>
        </div>

        <!-- 理由2 -->
        <div class="reason-item">
          <div class="reason-content">
            <div class="reason-title">零摩擦落地保障，更简单</div>

            <!-- 勾选列表 -->
            <div class="tick-list">
              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span class="tick-label">基于预封装电商接口，通过可视化路由配置器，最快3分钟即可完成客服系统对接与知识库初始化，旧系统改造全程业务0中断。</span>
                </div>
              </div>

              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span
                    class="tick-label">部署后自动启动「7天数据驯化」——前3天学习咨询日志优化应答策略，后4天开启A/B测试对比人工客服指标，保障咨询转化率提升≥32%（签约企业实测均值）</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 保留整个图片 -->
          <div class="reason-img-wrap">
            <img :src="reasonImg2" alt="零摩擦落地保障" class="reason-img reason-img2" />
          </div>
        </div>

        <!-- 理由3 -->
        <div class="reason-item">
          <div class="reason-content">
            <div class="reason-title">全域生态无缝融合，更快捷</div>

            <!-- 勾选列表 -->
            <div class="tick-list">
              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span class="tick-label">深度适配淘宝/京东/抖音/快手/微信生态，同步扩展Amazon/Shopify/TikTok Shop，让智能客服无时差覆盖每个商机触点。</span>
                </div>
              </div>

              <div class="tick-item">
                <img :src="tickIcon" alt="勾选" class="tick-icon" />
                <div class="tick-text">
                  <span
                    class="tick-label">结合订单时效/用户活跃时段/历史付款习惯（如支付宝偏好），在黄金3小时内触发个性化催付——未支付高客单用户推送“专属库存保留”消息，犹豫期消费者自动发放限时运费险。情感化交互：实时识别焦虑→
                    共情（“完全理解您着急的心情”）→ 解决（优先发货+进度直播），差评拦截成功率达92%。</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 保留整个图片 -->
          <div class="reason-img-wrap">
            <img :src="reasonImg3" alt="全域生态无缝融合" class="reason-img reason-img3" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import switchImg1 from '../../assets/img/home/mobile/switch_img1.png'
import switchImg2 from '../../assets/img/home/mobile/switch_img2.png'
import hoverBg from '../../assets/img/home/mobile/hover_bg.png'
import tickIcon from '../../assets/img/home/mobile/tick_icon.png'
import reasonImg1 from '../../assets/img/home/mobile/reason_img1.png'
import reasonImg2 from '../../assets/img/home/mobile/reason_img2.png'
import reasonImg3 from '../../assets/img/home/mobile/reason_img3.png'

export default {
  name: 'HomeMobile',
  data() {
    return {
      currentIndex: 0,
      switchImg1,
      switchImg2,
      hoverBg,
      tickIcon,
      reasonImg1,
      reasonImg2,
      reasonImg3,

      section2List: [
        {
          title: '原生级',
          subtitle: '性能优化',
          desc: ['各平台CPU占用率<15% 各平台CPU占用率<15%']
        },
        {
          title: '军工级',
          subtitle: '安全部署',
          desc: ['敏感数据本地沙盒处理 0云端存储']
        },
        {
          title: '模块化',
          subtitle: '无缝集成',
          desc: ['SDK/API/插件三种接入模式 最快三分钟部署']
        },
        {
          title: '基因级',
          subtitle: '业务定制',
          desc: ['支持200+定制参数配置 从界面到业务流程全栈可定制']
        }
      ],
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.page-content-mobile {
  @include mobile.mobile-page-content;
  background-color: #F5F7FB;
  // 头部banner

  .banner {
    width: 100%;
    height: mobile.px2rem(284);
    background: url('../../assets/img/home/mobile/banner.png') no-repeat center center;
    background-size: cover;
    text-align: center;
    margin-bottom: mobile.px2rem(24);

    .introduce {
      padding-top: mobile.px2rem(24);

      .introduce-title {
        font-weight: bold;
        font-size: mobile.px2rem(24);
        color: #272D5F;
        margin-bottom: mobile.px2rem(6);
      }

      .introduce-desc {
        font-weight: 500;
        font-size: mobile.px2rem(16);
        color: #272D5F;
      }
    }
  }

  // 通用section样式
  .section {
    .title-box {
      text-align: center;

      .title-text {
        font-weight: 800;
        font-size: mobile.px2rem(20);
        line-height: mobile.px2rem(20);
        background: linear-gradient(90deg, #00A1FF 20%, #0F3FFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin-bottom: mobile.px2rem(8);
      }

      .title-text2 {
        margin-top: mobile.px2rem(8);
      }

      .title-line {
        font-weight: 500;
        font-size: mobile.px2rem(14);
        color: #333333;
      }
    }
  }

  // 切换按钮区域
  .switch-section {
    padding: 0 mobile.px2rem(15);

    .switch-buttons {
      margin-top: mobile.px2rem(17);
      margin-bottom: mobile.px2rem(16);
      display: flex;

      .switch-btn {
        width: 50%;
        background: #f8f9fa;
        border-radius: mobile.px2rem(4);
        padding: (mobile.px2rem(7) 0);
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
          color: #fff;
          background: linear-gradient(90deg, #00A1FF 0%, #0f3fff 100%);
        }

        .switch-btn-title {
          font-weight: 500;
          font-size: mobile.px2rem(14);
        }
      }
    }

    .switch-images {
      text-align: center;
      margin-bottom: mobile.px2rem(24);

      .switch-img-box {
        .switch-img {
          width: 100%;
          height: mobile.px2rem(220);
          border-radius: mobile.px2rem(8);
        }
      }
    }
  }

  // 特性网格
  .features-grid {
    display: flex;
    flex-direction: column;
    gap: mobile.px2rem(12);
    margin-bottom: mobile.px2rem(21);
    margin-top: mobile.px2rem(16);
    padding: mobile.px2rem(0) mobile.px2rem(15);

    .feature-card {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: mobile.px2rem(4);
      padding: (mobile.px2rem(22) 0);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      text-align: center;
      position: relative;

      .feature-header {
        display: flex;
        justify-content: center;
        align-items: baseline;
        margin-bottom: mobile.px2rem(17);
        font-size: mobile.px2rem(18);
        font-weight: 800;

        .feature-title {
          color: #1890ff;
        }

        .feature-subtitle {
          color: #333;
        }
      }

      .feature-desc {
        font-weight: 500;
        font-size: mobile.px2rem(13);
        color: #333;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  // 理由列表
  .reasons {
    // margin-bottom: mobile.px2rem(20);
    margin-top: mobile.px2rem(20);
    padding: 0 mobile.px2rem(15);

    .reason-item {
      margin-bottom: mobile.px2rem(20);
      background: #fff;
      border-radius: 12px;
      padding: (mobile.px2rem(14) mobile.px2rem(10) mobile.px2rem(21));

      .reason-img-wrap {
        text-align: center;
        margin-top: mobile.px2rem(16);

        .reason-img {
          width: 100%;
          border-radius: mobile.px2rem(8);
        }

        .reason-img1 {
          height: mobile.px2rem(209);
        }

        .reason-img2 {
          height: mobile.px2rem(241);
        }

        .reason-img3 {
          height: mobile.px2rem(223);
        }
      }

      .reason-content {
        .reason-title {
          font-size: mobile.px2rem(16);
          font-weight: 800;
          text-align: center;
          color: #333;
          margin-bottom: mobile.px2rem(14);
        }

        // 勾选列表样式
        .tick-list {
          .tick-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: mobile.px2rem(6);

            &:last-child {
              margin-bottom: 0;
            }

            .tick-icon {
              width: mobile.px2rem(12);
              height: mobile.px2rem(12);
              margin-right: mobile.px2rem(8);
              margin-top: mobile.px2rem(4);
              flex-shrink: 0;
            }

            .tick-text {
              flex: 1;
              font-size: mobile.px2rem(12);
              font-weight: 500;
              color: #333;
              text-align: left;

              .tick-label {}
            }
          }
        }
      }
    }
  }
}
</style>